import React, { useEffect, useState } from "react";
import * as CronofyElements from "cronofy-elements";

const DateTimePickerWrapper = ({ options }) => {
    const [element, setElement] = useState(null);
    const targetId = "cronofy-date-time-picker";
    const combinedOptions = { ...options, target_id: targetId };

    useEffect(() => {
        if (!element) {
            setElement(
                CronofyElements.DateTimePicker(combinedOptions)
            );
        }
    }, []);

    useEffect(() => {
        if (element) {
            element.update(combinedOptions);
        }
    }, [options]);

    return <div id={targetId} />;
};

export default DateTimePickerWrapper;